import React, { PropsWithChildren, createContext, useContext } from 'react';
import useYellowhiveFlowProductsBasketStore from '@flows/src/store/zustand/flows-products/useYellowhiveFlowProductsBasketStore';

const YellowHiveBasketCalculationContext = createContext<ReturnType<
  typeof useYellowhiveFlowProductsBasketStore
> | null>(null);

export const useYellowHiveBasketCalculation = () => {
  const context = useContext(YellowHiveBasketCalculationContext);
  if (!context) {
    throw new Error(
      'useYellowHiveBasketCalculation must be used within a YellowHiveBasketCalculationProvider',
    );
  }
  return context;
};

interface Props {
  sessionId: string;
}

const YellowHiveBasketCalculationProvider: React.FC<
  PropsWithChildren<Props>
> = ({ children, sessionId }) => {
  const basketStore = useYellowhiveFlowProductsBasketStore();

  return (
    <YellowHiveBasketCalculationContext.Provider value={basketStore}>
      {children}
    </YellowHiveBasketCalculationContext.Provider>
  );
};

export default YellowHiveBasketCalculationProvider;
